<nz-layout>
    <nz-header class="section-header">
      {{ "Comorbidities" | translate }}
    </nz-header>
    <nz-content>
      <ng-container>
        <app-comorbidity />
      </ng-container>
    </nz-content>
  </nz-layout>